import { render, staticRenderFns } from "./QrCodeModule.vue?vue&type=template&id=84417488&scoped=true"
import script from "./QrCodeModule.vue?vue&type=script&lang=js"
export * from "./QrCodeModule.vue?vue&type=script&lang=js"
import style0 from "./QrCodeModule.vue?vue&type=style&index=0&id=84417488&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84417488",
  null
  
)

export default component.exports